import { getDefaultPath } from '../../helpers/urlSync';
import actions, { getView } from './actions';
import { themeConfig } from '../../settings';

const preKeys = getDefaultPath();
const topbarHeight = 65;
const initState = {
  // collapsed: window.innerWidth > 1220 ? false : true,
  collapsed: true,
  current: preKeys,
  showBreadCrumb: themeConfig.showBreadCrumb,
  fixedNavbar: themeConfig.fixedNavbar,
  view: getView(window.innerWidth),
  height: window.innerHeight,
  bredHeight: 0,
  scrollHeight: window.innerHeight - topbarHeight,
  openKeys: preKeys,
  userData: {},

  updatingExtendedProfile: false,
  updatingExtendedProfileFailed: null,
  updatingExtendedProfileSuccess: null,

  updatingPassword: false,
  updatingPasswordFailed: null,
  updatingPasswordSuccess: null,

  billingPostcodes: [],
  contactPostcodes:[],
  contactAddress: {},
  billingAddress: {},
  billingAddressVisible: false,
  addressSaved: false
};

export default function appReducer(state = initState, action) {
  switch (action.type) {
    case actions.COLLPSE_CHANGE:
      return {
        ...state,
        collapsed: !state.collapsed,
      };
    case actions.COLLPSE_OPEN_DRAWER:
      return {
        ...state,
        openDrawer: !state.openDrawer,
      };
    case actions.TOGLLE_FIXED_NAVBAR:
      return {
        ...state,
        fixedNavbar: !state.fixedNavbar,
      };
    case actions.TOGGLE_BILLING_ADDRESS:
      return {
        ...state,
        billingAddressVisible: !state.billingAddressVisible,
      };
    case actions.TOGGLE_ALL:
      if (state.view !== action.view || action.height !== state.height) {
        const height = action.height ? action.height : state.height;
        const bredHeight = 0;
        const scrollHeight = height - bredHeight - topbarHeight;
        return {
          ...state,
          collapsed: action.collapsed,
          view: action.view,
          height,
          scrollHeight,
          bredHeight,
        };
      }
      break;
    case actions.TOGLLE_SHOW_BREADCRUMB:
      return {
        ...state,
        showBreadCrumb: !state.showBreadCrumb,
      };
    case actions.CHANGE_BRED_HEIGHT: {
      const height = state.height;
      const scrollHeight = height - action.bredHeight - topbarHeight;
      return {
        ...state,
        bredHeight: action.bredHeight,
        scrollHeight,
      };
    }
    case actions.CHANGE_OPEN_KEYS:
      return {
        ...state,
        openKeys: action.openKeys,
      };
    case actions.CHANGE_CURRENT:
      const fixedNavbar = state.fixedNavbar;
      const view = state.view;
      let collapsed = state.collapsed;
      if (fixedNavbar && view !== 'DesktopView') {
        collapsed = true;
      }
      return {
        ...state,
        current: action.current,
        collapsed,
      };
    case actions.SET_USER_DATA:
      return {
        ...state,
        userData: action.userData,
      }
    case actions.UPDATE_EXTENDED_PROFILE:
      return {
        ...state,
        updatingExtendedProfile: true,
        updatingExtendedProfileFailed: null,
        updatingExtendedProfileSuccess: null,
      }
    case actions.UPDATE_EXTENDED_PROFILE_SUCCESS:
      return {
        ...state,
        updatingExtendedProfile: false,
        updatingExtendedProfileFailed: null,
        updatingExtendedProfileSuccess: action.payload,
      }
    case actions.UPDATE_EXTENDED_PROFILE_FAILED:
      return {
        ...state,
        updatingExtendedProfile: false,
        updatingExtendedProfileFailed: action.payload,
        updatingExtendedProfileSuccess: null,
      }
    case actions.UPDATE_EXTENDED_PROFILE_RESET:
      return {
        ...state,
        updatingExtendedProfile: false,
        updatingExtendedProfileFailed: null,
        updatingExtendedProfileSuccess: null,
      }

    case actions.UPDATE_PASSWORD:
      return {
        ...state,
        updatingPassword: true,
        updatingPasswordFailed: null,
        updatingPasswordSuccess: null,
      }
    case actions.UPDATE_PASSWORD_SUCCESS:
      return {
        ...state,
        updatingPassword: false,
        updatingPasswordFailed: null,
        updatingPasswordSuccess: action.payload,
      }
    case actions.UPDATE_PASSWORD_FAILED:
      return {
        ...state,
        updatingPassword: false,
        updatingPasswordFailed: action.payload,
        updatingPasswordSuccess: null,
      }
    case actions.UPDATE_PASSWORD_RESET:
      return {
        ...state,
        updatingPassword: false,
        updatingPasswordFailed: null,
        updatingPasswordSuccess: null,
      }
    case actions.ON_BILLING_POSTCODE_LOOKUP:
      return {
        ...state,
        billingPostcodes: action.payload.addresses,
      }
    case actions.ON_CONTACT_POSTCODE_LOOKUP:
      return {
        ...state,
        contactPostcodes: action.payload.addresses,
      }
    case actions.ON_ADDRESS_SAVED:
      return {
        ...state,
        addressSaved: true,
      }
    case actions.ON_RESET_ADDRESS_SAVED:
      return {
        ...state,
        addressSaved: false,
      }

    default:
      return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/app/reducer.js